import { render, staticRenderFns } from "./LinkPago.vue?vue&type=template&id=4c477834&lang=pug&"
import script from "./LinkPago.vue?vue&type=script&lang=js&"
export * from "./LinkPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports